(ns ncr.widgets.dialogs
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.pf :as pf]
   [ncr.etc.modal :as m]))

(defn- c-input-dialog [props initial]
  (let
    [ref (uix/ref)
     {:keys [submit register-pf] :as form}
     (rhf/use-form {:shouldFocusError false :default-values {:value initial}})

     modal-id :input-dialog-modal]

    (m/use-submit-form modal-id ref submit)

    (u/without [label] props
      [m/c-modal
       (w/merge-props
         {:variant :medium
          :id modal-id
          :ref ref
          :actions
          [[pf/c-button
            {:variant :primary
             :on-click submit}
            "Ok"]
           [pf/c-button
            {:variant :link :on-click #(m/close! nil)} "Cancel"]]}
         props)

       [pf/c-form
        {:on-submit submit}
        (let [id (uix/memo #(gensym) [])]
          [rhf/c-form-group {:label label :is-required true :field-id id} :value form
           [pf/c-text-input
            (merge (register-pf :value {:required true}) {:id id})]])]])))

(defn !input-dialog [props initial]
  (go
    (when-let [{:keys [value]} (<! (m/!modal #'c-input-dialog props initial))]
      value)))
